import * as React from 'react';
import { Result } from 'antd';
import './NotFoundPage.scss';
import { PageLayout } from 'client/ui/layout/PageLayout';
import { CorePageLayout } from 'client/ui/layout/CorePageLayout';

export interface INotFoundPageProps {}

export function NotFoundPage(props: INotFoundPageProps) {
  return (
    <CorePageLayout>
      <Result status="error" title="404" subTitle="Pagina Non Trovata." />
    </CorePageLayout>
  );
}
